// Visual tokens for the Leaves tab, taken from the "Brisk Olive Leaves – UI
// Redesign" mock-ups. Kept local to the Leaves screens (the portal's own
// ACCENT now comes from ./shared so every Leaves screen matches the portal).
// The portal's own accent (one source of truth); the darker shade is its hover.
export { ACCENT } from './shared';
export const ACCENT_DARK = '#1f2d0e';
export const ACCENT_SOFT = '#F1F5E4';
export const INK = '#1F2410';
export const MUTED = '#5B6250';
export const BODY = '#4A5140';
export const LINE = '#DDE3CF';
export const LINE_SOFT = '#ECEFE3';
export const FIELD = '#C9D2B4';
export const PAGE_BG = '#F5F7EF';
export const FONT = 'Inter, system-ui, sans-serif';
export const card = { bgcolor: 'white', border: `1px solid ${LINE}`, borderRadius: '14px' };
// Leave type → tile colours. Keyed by the short code the UI shows.
const TYPE = {
    EL: { tint: '#E6EDFD', ink: '#1D4ED8' },
    CL: { tint: '#DDF1F5', ink: '#0E6A82' },
    SL: { tint: '#FDF0E1', ink: '#A4460A' },
    CO: { tint: '#F0E9FD', ink: '#6D28D9' },
    UL: { tint: '#EEF0F2', ink: '#4B5563' },
};
const ALIAS = { COMP: 'CO', UNPAID: 'UL' };
const NEUTRAL = { tint: '#EEF0F2', ink: '#4B5563' };
export function typeTheme(code) {
    const c = (code || '').toUpperCase();
    return TYPE[ALIAS[c] || c] || NEUTRAL;
}
// Request status → the three pills in the mock-up (plus draft / cancelled).
export function statusPill(status) {
    switch (status) {
        case 'approved': return { label: 'Approved', bg: '#E3F1E1', ink: '#24632A' };
        case 'to_approve':
        case 'second_approval': return { label: 'Pending', bg: '#FDF0E1', ink: '#8A3B06' };
        case 'refused': return { label: 'Rejected', bg: '#FBE4E4', ink: '#9B1C1C' };
        case 'cancelled': return { label: 'Cancelled', bg: '#EEF0F2', ink: '#4B5563' };
        default: return { label: 'Draft', bg: '#EEF0F2', ink: '#4B5563' };
    }
}
// One-line help under each balance card, by short code.
export const TYPE_HINT = {
    EL: 'For planned holidays and trips.',
    CL: 'For short personal work.',
    SL: 'When you are unwell.',
    CO: 'Earned by working on a holiday or weekend. Added by HR.',
    UL: 'Used when paid balance runs out. Affects salary.',
};
